import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Optional, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ErrorDialogData } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './error.dialog.html',
    styleUrls: ['./error.dialog.scss'],
})
export class ErrorDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    public type: string;
    public errorMsg: string;
    public errorMsgParams: object;

    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        public dialogRef: MatDialogRef<ErrorDialog>,
        @Optional() @Inject(MAT_DIALOG_DATA) data: ErrorDialogData
    ) {
        super(parentEvents, el, renderer);
        this.type = data ? data.type || 'error' : 'error';
        this.errorMsg = data ? data.text || 'error.general' : 'error.general';
        this.errorMsgParams = data ? data.textParams || {} : {};
    }

    onClose() {
        this.dialogRef.close();
    }
}
